//import axios from 'axios';
//import authHeader from './auth-header';
import api from "./api";//Added 2024-04-18 for refreshToken

class MgroupTuneDataService {
  update(id, data) {
    //return axios.put(process.env.VUE_APP_ROOT_API + `mgrouptunes/${id}`, data, { headers: authHeader() }); //Replaced 2024-04-18 due to RefreshToken
    return api.put(`mgrouptunes/${id}`, data);
  }
}

export default new MgroupTuneDataService();